
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","height":"26","width":"29","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.883 12.061L4.82 8.178c.547-.546 1.367-.546 1.86 0 .547.493.547 1.313 0 1.86l-1.696 1.695h4.704c.765 0 1.312.547 1.312 1.313 0 .71-.547 1.312-1.313 1.312H4.984l1.696 1.695a1.198 1.198 0 010 1.805c-.492.547-1.313.547-1.86 0L.883 13.921c-.492-.492-.492-1.313 0-1.86zm18.43-.383h4.757l-1.695-1.695c-.547-.492-.547-1.312 0-1.86a1.287 1.287 0 011.805 0l3.937 3.938c.547.547.547 1.367 0 1.86l-3.937 3.937a1.198 1.198 0 01-1.805 0c-.547-.492-.547-1.312 0-1.86l1.695-1.695h-4.758c-.71 0-1.312-.546-1.312-1.312a1.33 1.33 0 011.313-1.313zm-6.125 12.25V2.053c0-.71.601-1.312 1.312-1.312.766 0 1.313.602 1.313 1.312v21.875c0 .766-.547 1.313-1.313 1.313-.71 0-1.313-.547-1.313-1.313z"}})])
          )
        }
      }
    